module.exports = __webpack_public_path__ + "static/giftwrap-b98262fb7c0538165a0afd8818588675.png";